export const dataFirstViewPerso = {
  description:
    'Voici votre besoin principal dans votre vie personnelle. La satisfaction de vos besoins est à la source de votre bien-être. Il est important que les relations que vous développez dans cette sphère de vie contribuent à satisfaire vos besoins. Ceci évitera les tensions et favorisera l’harmonie et la bonne entente.',
};
